export default "__VITE_ASSET__BD_kHA_O__"